import { MessageSquare, FileText, DollarSign } from "lucide-react";
import type { NotificationType } from "@/interfaces/notification.interface";

export interface NotificationTypeIconProps {
  type: NotificationType;
  size?: "sm" | "md";
  className?: string;
}

export function NotificationTypeIcon({
  type,
  size = "md",
  className,
}: NotificationTypeIconProps) {
  const sizeClass = size === "sm" ? "size-[20px]" : "size-[24px]";

  const iconMap: Record<NotificationType, React.ReactNode> = {
    Mensagem: <MessageSquare className={`${sizeClass} text-white`} />,
    Alerta: <FileText className={`${sizeClass} text-white`} />,
    Pagamento: <DollarSign className={`${sizeClass} text-white`} />,
  };

  return (
    <div className={`relative shrink-0 ${sizeClass} ${className || ""}`}>
      {iconMap[type]}
    </div>
  );
}
